import {isObject, isArray} from "./helpers";
import { normalizeBlockContentNodes } from '@blocks-helpers'


const isTranslationNode = (obj) => {
    return (isObject(obj) && obj.hasOwnProperty('translation') && isArray(obj['translation']));
}

const translateNode = (obj,locale) => {
    let selectedTranslation = null;
    for (let translation of obj['translation']){
        const translationEntries = Object.entries(translation);
        for (let i = 0; i < translationEntries.length; i += 1) {
            const [transKey, transValue] = translationEntries[i];
            if (transKey === 'locale' && transValue === locale) {
                selectedTranslation = translation;
                break;
            }
        }
        if (selectedTranslation) break;
    }
    if (selectedTranslation) {
        Object.keys(selectedTranslation).forEach(key => {
            if (key !== 'locale' && obj.hasOwnProperty(key) && selectedTranslation[key]){
                obj[key] = selectedTranslation[key];
            }
        });
    }
    delete obj['translation'];
}

const findNodeWithTranslation = (object,locale) => {
    if (isTranslationNode(object)){
        translateNode(object,locale)
    }

    if (isObject(object)){
        for (let key in object){
            if (isObject(object[key]) || isArray(object[key])){
                findNodeWithTranslation(object[key],locale)
            }
        }
    }
    else if (isArray(object)){
        for (let arrayEle of object){
            findNodeWithTranslation(arrayEle,locale)
        }
    }
};

export const translateBlockContentNodes = (data, {locale}) => {
    const { allBlockContent } = data
    const translatedBlockContent = structuredClone(normalizeBlockContentNodes(allBlockContent?.nodes));

    findNodeWithTranslation(translatedBlockContent,locale)

    return translatedBlockContent;
};

export const translateNodes = (nodes, {locale}) => {
    const translatedNodes = structuredClone(nodes)

    findNodeWithTranslation(translatedNodes,locale)

    return translatedNodes;
}

export const translatePostNodes = (nodes, nodesTranslated, {locale,defaultLang}) => {
    if (locale===defaultLang) { return nodes }

    let translatedPosts

    if (isArray(nodes)){
        translatedPosts = []
        for (let nodeEle of nodes){
            let translatedPost = nodesTranslated.find(post => post.slug === nodeEle.slug)
            if (translatedPost) {
                translatedPosts.push(translatedPost)
            }
            else {
                translatedPosts.push(nodeEle)
            }
        }
    }
    else if (isObject(nodes)){
        translatedPosts = nodes
        if (nodesTranslated && nodesTranslated.slug === nodes.slug){
            translatedPosts = nodesTranslated
        }
    }

    findNodeWithTranslation(translatedPosts,locale)
    return translatedPosts;
};

export const separatePostsByTranslation = (nodes, nodesTranslated, {locale, defaultLang}) => {
    // For default language, all posts are "translated" (they are the source)
    if (locale === defaultLang) {
        return {
            translatedPosts: nodes,
            untranslatedPosts: []
        }
    }

    const translatedPosts = []
    const untranslatedPosts = []

    if (isArray(nodes)) {
        for (let nodeEle of nodes) {
            let translatedPost = nodesTranslated.find(post => post.slug === nodeEle.slug)
            if (translatedPost) {
                // Post has translation - use the translated version
                translatedPosts.push(translatedPost)
            } else {
                // Post doesn't have translation - keep original but mark it
                untranslatedPosts.push(nodeEle)
            }
        }
    }

    // Apply any nested translations (for author, category, etc.)
    findNodeWithTranslation(translatedPosts, locale)
    findNodeWithTranslation(untranslatedPosts, locale)

    return {
        translatedPosts,
        untranslatedPosts
    }
};